import HandPeopleIcon from './HandPeopleIcon'

export default HandPeopleIcon
